import { Title } from '@solidjs/meta'
import type { Component } from 'solid-js'
import Layout from './(public)/_layout'
import Landing from './(public)/index'

const IndexPage: Component = () => {
  return (
    <>
      <Title>Florez Jaramillo Solutions | Desarrollo Web, Apps y Software a Medida | Colombia</Title>
      <Layout>
        <Landing />
      </Layout>
    </>
  )
}

export default IndexPage
